import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
export const LayoutContainer = ({ children, className }) => {
    return (_jsx("div", { className: clsx('container mx-auto px-4 sm:px-6', className, !className?.includes('max-w') ? 'max-w-7xl' : undefined), children: children }));
};
//# sourceMappingURL=index.js.map